<template>
  <div class="vFooter">
    {{setting==null?'':setting.shnm[0].codeName}}&nbsp;{{setting==null?'':setting.shnmEng[0].codeName}}<br />
    地址：<a href="http://web2.ncut.edu.tw/files/11-1000-24.php" target="_blank" title="交通資訊">{{setting==null?'':setting.shAdd[0].codeName}}</a><br />
    電話：{{setting==null?'':setting.contactWindow[0].codeName}}<br /><br />
    ©2020 - 國立勤益科技大學, 建議使用 Firefox 36.0+、Chrome、Safari、Microsoft Edge 瀏覽器
  </div>
</template>

<script>
export default {
  name: 'vFooter',
  computed: {
    setting () {
      return this.$store.getters.getSetting
    }
  },
  methods: {
    login: function () {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  text-align: center;
  font-size: 12px;
  background: transparent;
}

.footer {
  text-align: right;
  font-size: 12px;
  background: transparent;
  padding: 0.5em 1.25em;
}
</style>
